// @ts-nocheck
import getApiUrl from "./api.services";
import { Platform } from "react-native";
import loadImage from "blueimp-load-image";
import { post } from "./http";

class FileService {
  async uploadImage(file: any) {
    const baseUrl = await getApiUrl();
    const BASE = baseUrl + "/files";
    const formData = new FormData() as any;
    const uriParts = file.split(".");
    const fileType = uriParts[uriParts.length - 1];
    if (Platform.OS === "web") {
      const response = await fetch(file);
      const blob = await response.blob();
      const resetFile = await resetRotation(blob);
      formData.append("file", resetFile, "temp." + getFileExtension(file));
    } else {
      formData.append("file", {
        name: getFileName(file),
        type: `image/${fileType}`,
        uri: Platform.OS === "ios" ? file.replace("file://", "") : file,
      });
    }

    const url = `${BASE}/user_temp`;
    return post({
      url,
      params: formData,
      config: {
        withCredentials: true,
        headers: {
          "content-type": "multipart/form-data",
        },
      },
    }) as Promise<{ value: string }>;
  }
}

export default new FileService();

function getFileName(file: any): string {
  let imgName = file.name;
  if (typeof imgName === "undefined") {
    const getFilename = file.split("/");
    imgName = getFilename[getFilename.length - 1];
  }
  return imgName;
}

function getFileExtension(file: string) {
  const indexOfSlash = file.indexOf("/");
  const indexOfSemicolon = file.indexOf(";");

  return file.substring(indexOfSlash + 1, indexOfSemicolon);
}

function resetRotation(file: any) {
  return new Promise((resolve) => {
    getOrientation(file, (orientation: any) => {
      if (orientation <= 1) {
        // if image has no orientation set
        resolve(file);
      } else {
        // if image has orientation set, resets the image orientation
        loadImage(file, {
          orientation: true,
          canvas: true,
          meta: true,
        })
          .then((data) => {
            return new Promise((resolve) => {
              data.image.toBlob((blob) => {
                data.blob = blob;
                resolve(data);
              }, "image/jpeg");
            });
          })
          .then((data) => {
            return loadImage.replaceHead(data.blob, data.imageHead);
          })
          .then((blob) => {
            const rotatedImg = new File([blob], "temp.jpeg");
            resolve(rotatedImg);
          })
          .catch((error) => {
            resolve(file);
          });
      }
    });
  });
}

function getOrientation(file: any, callback: any) {
  var reader = new FileReader();

  reader.onload = function (event: any) {
    var view = new DataView(event.target.result);

    if (view.getUint16(0, false) != 0xffd8) return callback(-2);

    var length = view.byteLength,
      offset = 2;

    while (offset < length) {
      var marker = view.getUint16(offset, false);
      offset += 2;

      if (marker == 0xffe1) {
        if (view.getUint32((offset += 2), false) != 0x45786966) {
          return callback(-1);
        }
        var little = view.getUint16((offset += 6), false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;

        for (var i = 0; i < tags; i++)
          if (view.getUint16(offset + i * 12, little) == 0x0112)
            return callback(view.getUint16(offset + i * 12 + 8, little));
      } else if ((marker & 0xff00) != 0xff00) break;
      else offset += view.getUint16(offset, false);
    }
    return callback(-1);
  };

  reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
}
